import axios from 'axios'
import { getToken } from './token'
import state from '@/state'

const BASE_URL = process.env.VUE_APP_EREPORTING_API_URL || 'https://europe-west1-ai-fisk-prod.cloudfunctions.net/reports'

const api = axios.create({
  baseURL: BASE_URL,
  timeout: 30000
})

api.interceptors.request.use(async config => {
  try {
    const token = await getToken('documents')
    if (token) {
      config.params = {
        ...config.params,
        companyId: state.getCurrentCompany().id
      }
    }
  } catch (error) {
    console.error('Error getting company ID:', error)
  }
  return config
})

api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.data?.error) {
      error.parsedMessage = error.response.data.error
      if (error.response.data.details) {
        error.parsedMessage += ': ' + error.response.data.details
      }
    }
    return Promise.reject(error)
  }
)

export const ereportingApi = {
  async markAsPaid (payload) {
    const response = await api.post('/paid', payload)
    return response.data
  },

  async markAsPaidById (id, payload) {
    const response = await api.post(`/paid/${id}`, payload)
    return response.data
  },

  async markAsRejected (payload) {
    const response = await api.post('/rejected', payload)
    return response.data
  },

  async markAsRejectedById (id, payload) {
    const response = await api.post(`/rejected/${id}`, payload)
    return response.data
  },

  async getEReportingRequests (documentId, issueYear, companyId) {
    const response = await api.get('/requests', {
      params: {
        documentId,
        issueYear,
        companyId
      }
    })
    return response.data
  },

  async sendReport (payload) {
    const response = await api.post('/send', payload)
    return response.data
  }
}
